import { InterviewQuestion } from 'src/DTO/Job.type';

export const filterEmptyInterviewQuestions = (
  questions: InterviewQuestion[],
): InterviewQuestion[] => {
  return questions.filter(q => q.question.trim() !== '');
};

export const normalizeInterviewQuestions = (
  questions: InterviewQuestion[],
): InterviewQuestion[] => {
  return questions.map(q => ({
    ...q,

    description: q.description?.trim() === '' ? undefined : q.description,

    conclusion: q.conclusion?.trim() === '' ? undefined : q.conclusion,

    explanation: q.explanation?.trim() === '' ? undefined : q.explanation,

    points: q.points?.filter(
      value => typeof value === 'string' && value.trim() !== '' && value.trim() !== '\n',
    ),

    partDuration:
      q.partDuration == null || Number.isNaN(q.partDuration) ? undefined : q.partDuration,

    numOfRetakes:
      q.numOfRetakes == null || Number.isNaN(q.numOfRetakes) ? undefined : q.numOfRetakes,
  }));
};

export const cleanInterviewQuestions = (questions: InterviewQuestion[]): InterviewQuestion[] => {
  return filterEmptyInterviewQuestions(normalizeInterviewQuestions(questions));
};
